import { render, staticRenderFns } from "./GangmasterDetail.vue?vue&type=template&id=4b482518"
import script from "./GangmasterDetail.vue?vue&type=script&lang=js"
export * from "./GangmasterDetail.vue?vue&type=script&lang=js"
import style0 from "./GangmasterDetail.vue?vue&type=style&index=0&id=4b482518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports